import React, { createContext, useContext, useState } from 'react';

interface PrimeTooltipContextValue {
  isTooltipVisible: boolean;
  setIsTooltipVisible: (visible: boolean) => void;
}

export const PrimeTooltipStateContext = createContext<PrimeTooltipContextValue>(
  { isTooltipVisible: false, setIsTooltipVisible: () => {} }
);

const PrimeTooltipStateProvider = ({ children }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  return (
    <PrimeTooltipStateContext.Provider
      value={{ isTooltipVisible, setIsTooltipVisible }}
    >
      {children}
    </PrimeTooltipStateContext.Provider>
  );
};

export function usePrimeTooltipState() {
  const { isTooltipVisible, setIsTooltipVisible } = useContext(
    PrimeTooltipStateContext
  );

  return {
    isTooltipVisible,
    openTooltip: () => setIsTooltipVisible(true),
    closeTooltip: () => setIsTooltipVisible(false),
  };
}

export default PrimeTooltipStateProvider;
